<template>
    <div class="radio-border-div" :style="{borderColor:(value?'#4380FF':'#999999')}" @click="changeChecked">
        <img class="radio-img-class" v-show="value" src="../assets/flights/i_icon_choice _32px_@2x.png"  />
    </div>
</template>
<script>
export default {
    name:"jlkj-radio",
    props:{
        value:{
            type:Boolean
        },
        groupIndex:{
            type:String
        },
    },
    data(){
        return {
            defaultValue:this.theDefaultValue,
            ///value:this.value
            //theChecked:this.value
            //thisValue:this.value,
            //groupIndex:0
        }
    },
    watch:{

    },
    mounted(){

    },
    methods:{
        changeChecked:function(){
            if(this.value){
                this.$emit('change',false,this.groupIndex);
                // this.value=false;
            }else{
                this.$emit('change',true,this.groupIndex);
                // this.value=true;
            }
        }
    }
}
</script>
<style scoped>
    .radio-border-div{
        width:20px;
        height: 20px;
        border:1px solid transparent;
        border-radius: 11px ;
    }
    .radio-img-class{
        width: 20px;
        height: 20px;

    }
</style>
